import React, { forwardRef } from 'react';

// Components
import { Portal } from '../portal/Portal';
import { useMergeRefs, FloatingArrow } from '@floating-ui/react';

import './WpTooltipOverlay.scss';

const WpTooltipOverlay = forwardRef<HTMLDivElement, React.HTMLProps<HTMLDivElement> & { context }>(
  function WpTooltipOverlay({ children, context }, propRef) {
    const ref = useMergeRefs([context.refs.setFloating, propRef]);

    if (!context.open) return null;

    const baseClassName = 'WpTooltipOverlay';
    return (
      <Portal idPrefix="tooltip">
        <div
          ref={ref}
          style={{
            ...context.floatingStyles,
          }}
          className={baseClassName}
        >
          <FloatingArrow
            ref={context.arrowRef}
            context={context.context}
            tipRadius={2}
            className={`${baseClassName}__arrow`}
          />
          {children}
        </div>
      </Portal>
    );
  }
);

export default WpTooltipOverlay;
